export const isAnyConditionTrue = (...args: boolean[]): boolean =>
  args.some(arg => arg)
